export function orientationGeometry(width, height, orientation) {
    switch (orientation) {
        case 2:
            return { width, height, transform: [-1, 0, 0, 1, width, 0] };
        case 3:
            return { width, height, transform: [-1, 0, 0, -1, width, height] };
        case 4:
            return { width, height, transform: [1, 0, 0, -1, 0, height] };
        case 5:
            return { width: height, height: width, transform: [0, 1, 1, 0, 0, 0] };
        case 6:
            return { width: height, height: width, transform: [0, 1, -1, 0, height, 0] };
        case 7:
            return { width: height, height: width, transform: [0, -1, -1, 0, height, width] };
        case 8:
            return { width: height, height: width, transform: [0, -1, 1, 0, 0, width] };
        default:
            return { width, height, transform: [1, 0, 0, 1, 0, 0] };
    }
}
export function containSize(width, height, maxLongEdge) {
    const scale = Math.min(1, maxLongEdge / Math.max(width, height));
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
}
